import React, { useState } from 'react';
import SectionHeading from './SectionHeading';

const WaitingListForm = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [notification, setNotification] = useState(null);
    const [sending, setSending] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked); // Toggle checkbox state
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true)

        // Validate form fields
        if (!name || !email || !isChecked) {
            setNotification('Please fill out all fields and accept the terms.');
            return;
        }

        // Prepare the data to send
        const formData = {
            type: "WAITING_LIST",
            full_name: name,
            email: email
        };

        try {
            // Make the API call
            const response = await fetch('https://x8ki-letl-twmt.n7.xano.io/api:rsIn_jW5/WAITING_LIST', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setNotification('Form submitted successfully!');
                // Clear the form
                setName('');
                setEmail('');
                setIsChecked(false);
            } else {
                setNotification('Failed to submit the form. Please try again.');
            }
        } catch (error) {
            setNotification('An error occurred. Please try again later.');
        }

        setSending(false)
    };

    return (
        <div className="contact-form drop-shadow-2" >
            <div  className="contact-form-wrapper" >
                <SectionHeading
                    subHeading='REGÍSTRATE EN LA WAITING LIST'
                    additionalClasses='section-heading-2 center'
                />
                <form onSubmit={handleSubmit} >
                    <div className="form-floating">
                        <input 
                        className="input form-control" 
                        id="name-field" 
                        type="text" 
                        placeholder="Nombre completo" 
                        value={name}
                        onChange={(e) => { setName(e.target.value) }}
                        required
                        disabled={sending}
                        />
                        <label htmlFor="name-field">Nombre completo</label>
                    </div>
                    <div className="form-floating">
                        <input 
                        className="input form-control" 
                        id="email-field" 
                        type="text" 
                        placeholder="Dirección de correo electrónico" 
                        value={email}
                        onChange={(e) => { setEmail(e.target.value) }}
                        required
                        disabled={sending}
                        />
                        <label htmlFor="email-field">Dirección de correo electrónico</label>
                    </div>
                    <div className="mt-5 form-check mb-3 d-flex align-items-center" >
                         <input 
                            className="form-check-input me-3" 
                            type="checkbox" 
                            id="terms-checkbox" 
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                            required
                            style={{fontSize:"1.6rem"}}
                            disabled={sending}
                        />
                        <label htmlFor="terms-checkbox" style={{fontSize:"1.6rem"}}>
                            Acepto los <a class="woowii-a" href="/privacy-policy">términos y condiciones</a>
                        </label>
                    </div>
                    <button type="submit" className="button button-3" disabled={sending||notification}>
                        <span className="button-inner">
                            <span className="button-content">
                                <span className="text">Enviar</span>
                            </span>
                        </span>
                    </button>
                </form>
                {notification && 
                 <h4 class="mt-5" style={{textAlign:"center"}}>Pronto nos pondremos en contacto contigo!</h4>
                }
            </div>
        </div>
    );
};

export default WaitingListForm;
